import { ClientUserSsoProviderType } from "../Types-DTOs/ClientUser";
import { localStorageEffect } from "./Utils";
import { atom } from "recoil";

export type InvitationState = {
  ssoProvider: ClientUserSsoProviderType | undefined;
  ssoToken: string | undefined;
};

export const invitationState = atom<InvitationState>({
  key: "invitationState",
  default: {
    ssoProvider: undefined,
    ssoToken: undefined,
  } as InvitationState,
  effects: [localStorageEffect<InvitationState>("invitationState")],
});
